import React from 'react';
import { motion } from 'framer-motion';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { siteData } from '../data/mock';

const FAQ = () => {
  const { faq } = siteData;

  return (
    <section id="faq" className="py-20 md:py-32">
      <div className="container">
        <div className="max-w-3xl mx-auto">
          {/* Section Header */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="text-center mb-12"
          >
            <span className="inline-block px-4 py-1.5 rounded-full bg-[var(--accent-wash)] text-[var(--accent-text)] text-sm font-medium mb-4">
              FAQ
            </span>
            <h2 className="heading-2 mb-4">
              Frequently Asked Questions
            </h2>
            <p className="body-large">
              Got questions? We've got answers.
            </p>
          </motion.div>

          {/* Accordion */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.1 }}
          >
            <Accordion type="single" collapsible className="space-y-4">
              {faq.map((item, index) => (
                <AccordionItem
                  key={item.id}
                  value={`item-${item.id}`}
                  className="bg-white border border-black/10 rounded-xl px-6 overflow-hidden data-[state=open]:border-[var(--accent-primary)] transition-colors"
                >
                  <AccordionTrigger className="text-left font-semibold text-[var(--text-primary)] hover:no-underline py-5 [&[data-state=open]>svg]:text-[var(--accent-text)]">
                    {item.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-[var(--text-secondary)] leading-relaxed pb-5">
                    {item.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </motion.div>

          {/* Still have questions */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="text-center mt-12"
          >
            <p className="text-[var(--text-secondary)] mb-4">
              Still have questions? We're here to help.
            </p>
            <a href="#contact" className="btn-primary inline-flex">
              Get in Touch
            </a>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
